export const firebaseConfig = {
  apiKey: "AIzaSyA-q_dCYjpcVcnXhPrxqzEpKI_tOVPrVJE",
  authDomain: "scinutsh.firebaseapp.com",
  databaseURL: "https://scinutsh.firebaseio.com",
  projectId: "scinutsh",
  storageBucket: "",
  messagingSenderId: "28425979105",
  appId: "1:28425979105:web:d3a7390f618f679f"
}